import styled from 'styled-components';

export const StyledButton = styled.button`
	position: absolute;
	z-index: 10;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;

	background-color: transparent;
	width: 100%;
	border: none;

	${({ disabled }) => (disabled ? 'cursor: default;' : 'cursor: pointer;')}
`;
